"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UIMultiLevelDropdown = _interopRequireDefault(require("UIComponents/dropdown/UIMultiLevelDropdown"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: block !important;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var _default = (0, _styledComponents.default)(_UIMultiLevelDropdown.default).withConfig({
  displayName: "StyleProtectedUIMultiLevelDropdown",
  componentId: "sc-182s9fw-0"
})(_templateObject());

exports.default = _default;
module.exports = exports.default;